import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit, TemplateRef,
  ViewChild, ViewContainerRef,
} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {IMG_TYPE_PANOLENS} from '../../interfaces/constants';
import {ImagePanolensComponent} from '../image-panolens/image-panolens.component';
import {ImageInputService} from '@src/app/services/ImageInputService/image-input.service';
import {Item} from '@src/app/models/Item';
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent implements OnInit, OnDestroy {
  modalConfig: any = {};
  @ViewChild('modal', {static: false}) container: ElementRef;
  @ViewChild('panolens', {static: false}) panolens: ImagePanolensComponent;
  public Yiit = Yiit;
  public image = null;
  public item:Item = null;
  public imagesList:{val: string, title: string}[];
  public noWrapSlides = false;
  public activeSlideIndex = 0;

  public closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  panoLensFlag = false;

  get isPanolens(): boolean {
    return this.modalConfig.imgType === IMG_TYPE_PANOLENS;
  }

  @ViewChild('carouselComponent', { read: ViewContainerRef, static: false }) carouselComponentRef: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef, static: false }) contentRef: TemplateRef<any>;

  constructor(
    private cd: ChangeDetectorRef,
    private iis: ImageInputService,
    private im: ItemManagerService
  ) {
  }


  private initProps(){
    this.image = (this.iis.modalConfig.imageUrl && this.iis.modalConfig.imageUrl.val) ? this.iis.modalConfig.imageUrl.val : this.iis.modalConfig.imageUrl;
    this.item = this.iis.modalConfig.item;
    if (this.item){
      if (this.item.config.isCopy){
        this.item = this.im.getItemById(this.item.config.getCopyParentId);
      }
      let inputs = Object.values(this.item.config.getInputs()).filter( (input:any) => input.type && input.type === 'image' && !input.defaultValue);
      this.imagesList = [...inputs.map((i:{value, label}) => ({val: i.value, title: i.label})).filter(i=> i.val!=null && i.val!='undefined')];
      this.cd.detectChanges();
    }
    this.rerenderCarousel();
  }

  private rerenderCarousel(){
    if (this.carouselComponentRef){
      this.carouselComponentRef.clear();
      this.carouselComponentRef.createEmbeddedView(this.contentRef);
    }
  }

  ngOnInit() {
    this.updateConfig();


    this.iis.onOpenModal$().subscribe(()=>{
      this.openModal().subscribe();
    })

    this.iis.onModalClosed$().subscribe(()=>{
      this.hideModal();
    })

    this.iis.onModalConfigUpdated$.subscribe(()=>{
      this.updateConfig();
    })
  }

  ngOnDestroy() {
    this.hideModal();
  }

  updateConfig() {
    this.initProps();
    this.cd.detectChanges();
  }

  openModal(): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (this.imagesList) {
        jQuery(this.container.nativeElement).modal({backdrop: false, keyboard: false, show: true});
        jQuery(this.container.nativeElement).data('bs.modal')._config.backdrop = false;
        jQuery(this.container.nativeElement).data('bs.modal')._config.keyboard = false;
        observer.next(true);
      } else {
        observer.next(false);
        // observer.error(new Error('Image url is undefined'));
      }
    }).pipe(map((flag) => {
      this.panoLensFlag = flag;
      this.cd.detectChanges();
      return flag;
    }));
  }

  hideModal() {
    jQuery(this.container.nativeElement).modal('hide');
    if (this.panolens) {
      this.panolens.clean();
    }
    this.panoLensFlag = false;
  }

  moveToIndex(index: number) {
    this.activeSlideIndex = index;
    this.cd.detectChanges();
  }
}
